import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { highlightKeys } from './highlightKeys';
import { useTranslation } from 'react-i18next';

export interface IDeleteHighlightParams {
  id: number;
}

export const deleteHighlight = async (
  params: IDeleteHighlightParams
): Promise<void> => {
  const { id } = params;
  await EXPRESS_API.delete(`/highlights/${id}`);
};

export const useDeleteHighlightMutation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(deleteHighlight, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(highlightKeys.all());
      onSuccess?.();
      successToast({
        title: t(`Highlight has been successfully deleted!`),
      });
    },
    onError: error =>
      showError(
        error || t(`An error occurred while trying to delete the highlight.`)
      ),
  });
};
